import axios from "axios";
import React, { Fragment, useEffect, useState, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import {
    Card,
    CardBody,
    CardHeader,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    Col,
    Form,
} from "reactstrap";
import { Btn, H4, P } from "../../../../../AbstractElements";
// import { UserEditTableAPI } from '../../../../../api';
import { UserContext } from "./exp";
import Select from "react-select";
import { Close, Save } from "../../../../../Constant";
import CloseModal from "../../../../../Constant/CloseModal";
import {
    CreateTreatmentPlanMapping,
    TreatmentMethodList,
    TreatmentPlanList,
    TreatmentProcedureList,
} from "../../../../../apiController";
import { toast } from "react-toastify";

const TreatmentPlan = ({ setSteps }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const [treatmentdata, setData] = useState([]);
    const [treatmentPlan, setTreatmentPlan] = useState([]);
    const [treatmentProcedure, setTreatmentProcedure] = useState([]);
    const [treatmentMethod, setTreatmentMethod] = useState([]);
    const [filteredTreatmentProcedure, setFilteredTreatmentProcedure] = useState(
        []
    );
    const [filteredTreatmentMethod, setFilteredTreatmentMethod] = useState([]);

    const { data } = location.state || {};

    const options = [
        { value: "AL", label: "Alabama" },
        { value: "WY", label: "Wyoming" },
        { value: "WY", label: "Coming" },
        { value: "WY", label: "Hanry Die" },
        { value: "WY", label: "John Doe" },
    ];

    const planOptions = treatmentPlan.map((plan) => ({
        value: plan.id,
        id: plan.id,
        label: plan.treatment_plan,
        name: plan.treatment_plan,
    }));
    const procedureOptions = filteredTreatmentProcedure.map((plan) => ({
        value: plan.id,
        id: plan.id,
        sname: plan.treatment_procedure,
        label: plan.treatment_procedure,
    }));
    const methodOptions = filteredTreatmentMethod.map((plan) => ({
        value: plan.id,
        label: plan.treatment_method,
        id: plan.id,
        mname: plan.treatment_method,
        doctor_price: plan.doctor_price,
        price: plan.method_price,
    }));

    const [header, setHeader] = useState([
        "#",
        "Diagnosis Type",
        "Tooth No.",
        "Diagnosis Name",
        "Add Diagnosis Treatment",
        "Mapped Status",
    ]);

    const [items, setSelectedOptions] = useState([]);
    const [itemsP, setSelectedOptionsProcedure] = useState([]);
    const [itemsPr, setSelectedOptionsMethod] = useState([]);

    const handleChange = (selected) => {
        console.log(selected);
        setSelectedOptions(selected);
    };
    const handleChangeProcedure = (selected) => {
        setSelectedOptionsProcedure(selected);
    };
    const handleChangeMethod = (selected) => {
        setSelectedOptionsMethod(selected);
    };

    //console.log(selectedOptions);
    const [formdata, setFormdata] = useState({});
    const [treatment, setTreatment] = useState({});

    const [Large, setLarge] = useState(false);

    const contextValue = useContext(UserContext);

    const LargeModaltoggle = (trt, index) => {
        //console.log(trt, index);
        setTreatment({ ...trt, index });
        contextValue.toothSelection[index]["index"] = index;
        setLarge(!Large);
    };

    useEffect(() => {
        setData(contextValue.toothSelection);
        // getTreatmentPlan()
        console.log(contextValue.toothSelection);
    }, [contextValue.toothSelection]);
    // useEffect(() => {
    //   let isMounted = true;
    //   if (isMounted) {
    //     axios.get(contextValue).then((res) => setData(res.toothSelection));
    //   }
    //   return () => {
    //     isMounted = false;
    //   };
    // }, []);

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();
    const onSubmit = (data) => {
        setFormdata((prev) => ({ ...prev, ...data }));
        setSteps((prev) => prev + 1);
    };

    const item = {
        btnText: "Open",
        items: ["Open", "Pending", "Inprogress", "Completed", "Cancel"],
    };

    //console.log(treatmentdata);
    //console.log(treatment);

    const fetchTreatmentPlan = async () => {
        const response = await TreatmentPlanList();
        if (response.status === true) {
            let plan = await response.data;

            // //console.log(treatment)
            const filteredPlan = await plan.filter(
                (plan) => plan.diagnosis_id === treatment?.problem?.id
            );
            // //console.log(plan)
            // //console.log(filteredPlan)
            setTreatmentPlan(filteredPlan);
        }
    };
    const fetchTreatmentProcedure = async () => {
        const response = await TreatmentProcedureList();
        if (response.status === true) {
            setTreatmentProcedure(response.data);
        }
    };
    const fetchTreatmentMethod = async () => {
        const response = await TreatmentMethodList();
        if (response.status === true) {
            setTreatmentMethod(response.data);
        }
    };

    useEffect(() => {
        if (treatment?.problem?.id) {
            fetchTreatmentPlan();
        }

        fetchTreatmentMethod();
        fetchTreatmentProcedure();
    }, [treatment]);

    useEffect(() => {
        const filterProcedures = () => {
            if (items) {
                const selectedIds = items.map((option) => option.value);
                // console.log(selectedOptions)
                // console.log(selectedIds)
                // console.log(treatmentProcedure)
                const filtered = treatmentProcedure.filter((procedure) =>
                    selectedIds.includes(procedure.treatment_plan_id)
                );
                setFilteredTreatmentProcedure(filtered);
            } else {
                setFilteredTreatmentProcedure(treatmentProcedure);
            }
        };

        filterProcedures();
    }, [items, treatmentProcedure]);
    // console.log(selectedOptionsProcedure)
    useEffect(() => {
        const filterMethod = () => {
            // console.log(selectedOptionsProcedure)
            if (itemsP) {
                const selectedIds = itemsP.map((option) => option.value);
                // console.log(treatmentMethod)
                const filtered = treatmentMethod.filter((method) =>
                    selectedIds.includes(method.treatment_procedure_id)
                );
                setFilteredTreatmentMethod(filtered);
            } else {
                setFilteredTreatmentMethod(treatmentMethod);
            }
        };

        filterMethod();
    }, [itemsP, treatmentMethod]);

    const total = itemsPr.reduce((sum, item) => {
        return sum + parseFloat(item.price);
    }, 0);

    const handleSave = () => {
        if (!contextValue || !contextValue.toothSelection || !treatment) return;

        console.log(contextValue.toothSelection);
        // Extract the relevant index from trt
        const index = treatment.index;
        const data = treatment;

        // console.log(data);
        try {
            if (contextValue.toothSelection[index]) {
                contextValue.toothSelection[index]["data"] = data;
                contextValue.toothSelection[index]["items"] = items;
                contextValue.toothSelection[index]["itemsP"] = itemsP;
                contextValue.toothSelection[index]["itemsPr"] = itemsPr;
                contextValue.toothSelection[index]["discountPrice"] = total;
            }
        } catch (error) {
            console.error("Error updating context:", error);
        } finally {
            setLarge(!Large);
            setSelectedOptions([]);
            setSelectedOptionsProcedure([]);
            setSelectedOptionsMethod([]);
        }
    };

    console.warn(contextValue.toothSelection)
    console.warn(treatmentdata)

    const handleMapping = async () => {
        // console.log(data)
        for (let item of contextValue.toothSelection) {
            item['is_booked'] = false
        }
        console.log(contextValue.toothSelection)
        const book = {
            patient_treatment: contextValue.toothSelection,
            patient_id: data.id,
        };

        console.log(book);
        // setSteps((prev) => prev + 1);

        try {
            {
                const response = await CreateTreatmentPlanMapping(book);
                if (response.status === true) {
                    toast.success("Created Successfully!", {
                        position: toast.POSITION.TOP_CENTER,
                    });
                }
            }
        } catch (error) {
            toast.error("An error occurred!", {
                position: toast.POSITION.TOP_CENTER,
            });
        } finally {
            navigate("/patientinfo/summary", { state: { data: data } });
        }
    };

    return (
        <Fragment>
            <Card>
                <CardHeader className="d-flex justify-content-between">
                    <H4 attrH4={{ className: "card-title mb-0" }}>{"Schedule"}</H4>
                    <Btn
                        attrBtn={{
                            className: "focuse-none",
                            color: "danger",
                            size: "sm",
                            onClick: () =>
                                navigate(`/patientinfo/diagnosis`, { state: { data } }),
                        }}
                    >
                        Cancel
                    </Btn>
                </CardHeader>
                <div className="table-responsive edit-table">
                    <table className="table card-table table-vcenter text-nowrap">
                        <thead>
                            <tr>
                                {header.map((items, i) => (
                                    <th key={i}>{items}</th>
                                ))}
                            </tr>
                        </thead>
                        {!treatmentdata.includes("selected") ? (
                            treatmentdata.map((items, i) => (
                                <tbody>
                                    <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td>{items.type && items.type.toUpperCase()}</td>
                                        <td>{items.type === "tooth" ? items.tooth : "-"}</td>
                                        <td>
                                            {items.problem === undefined ? "-" : items.problem.name}
                                        </td>
                                        <td>
                                            {" "}
                                            <Btn
                                                attrBtn={{
                                                    className: "focuse-none",
                                                    color: "success",
                                                    size: "sm",
                                                    onClick: () => LargeModaltoggle(items, i),
                                                }}
                                            >
                                                {"Add Method"}
                                            </Btn>
                                        </td>
                                        <td>{items?.itemsPr?.length > 0? 'Mapped' :'not mapped'}</td>
                                    </tr>
                                </tbody>
                            ))
                        ) : (
                            <div className=" d-flex justify-content-center align-items-center ">
                                <div className="text-center">
                                    <p className="font-danger">Please select a diagnosis.</p>
                                </div>
                            </div>
                        )}
                    </table>
                    <Btn
                        className="d-flex justify-content-end"
                        attrBtn={{ color: "primary", onClick: handleMapping }}
                    >
                        {"Submit"}
                    </Btn>
                </div>

                <Modal isOpen={Large} toggle={LargeModaltoggle} size="lg" centered>
                    {/* <div className="d-flex justify-content-between text-white bg-dark align-items-center"> */}
                    <ModalHeader toggle={LargeModaltoggle}>
                        {"Add Treatment Plan"}
                    </ModalHeader>
                    {/* <div className='p-3' style={{cursor: "pointer"}} onClick={Large}> <CloseModal/> </div> */}

                    {/* </div> */}
                    <ModalBody className={"bodyClass"}>
                        <Card>
                            <CardBody>
                                <Form
                                    onSubmit={handleSubmit(onSubmit)}
                                    className="form-bookmark needs-validation"
                                >
                                    <Row className="mb-3" sm="12">
                                        <Col className="d-flex justify-content-center align-items-center gap-2">
                                            <Label>{"Diagnosis Type :"}</Label>
                                            <P>
                                                {treatment.type !== undefined ? treatment.type : "-"}
                                            </P>
                                        </Col>
                                        {treatment.type === "tooth" ? (
                                            <Col className="d-flex justify-content-center align-items-center gap-2">
                                                <Label>
                                                    <span>{"Tooth No :"}</span>
                                                </Label>
                                                <P>{treatment.tooth}</P>
                                            </Col>
                                        ) : (
                                            ""
                                        )}
                                        <Col className="d-flex justify-content-center align-items-center gap-2">
                                            <Label>{"Diagnosis :"}</Label>
                                            <P>
                                                {treatment.problem !== undefined
                                                    ? treatment.problem.name
                                                    : "-"}
                                            </P>
                                        </Col>
                                    </Row>

                                    <Row className="mb-3" sm="12">
                                        <Label className="col-form-label">Treatment Plan</Label>
                                        <Select
                                            options={planOptions}
                                            className="js-example-basic-single col-sm-12"
                                            onChange={handleChange}
                                            isMulti
                                        />
                                    </Row>
                                    <Row className="mb-3" sm="12">
                                        <Label className="col-form-label">
                                            Treatment Procedure
                                        </Label>
                                        <Select
                                            options={procedureOptions}
                                            className="js-example-basic-single col-sm-12"
                                            onChange={handleChangeProcedure}
                                            isMulti
                                        />
                                    </Row>
                                    <Row className="mb-3" sm="12">
                                        <Label className="col-form-label">Treatment Method</Label>
                                        <Select
                                            options={methodOptions}
                                            className="js-example-basic-single col-sm-12"
                                            onChange={handleChangeMethod}
                                            isMulti
                                        />
                                    </Row>

                                    <Row sm="12">
                                        <Col className="d-flex justify-content-center align-items-center gap-2">
                                            <Label>{"Treatment Price"}</Label>
                                            <P>{filteredTreatmentMethod.length > 0 ? total : "-"}</P>
                                        </Col>
                                    </Row>
                                </Form>
                            </CardBody>
                        </Card>
                    </ModalBody>
                    <ModalFooter>
                        <Btn attrBtn={{ color: "secondary", onClick: LargeModaltoggle }}>
                            {Close}
                        </Btn>
                        <Btn attrBtn={{ color: "primary", onClick: () => handleSave() }}>
                            {Save}
                        </Btn>
                        {/* <Btn attrBtn={{ color: 'primary', onClick: handleSave }}>{Save}</Btn> */}
                    </ModalFooter>
                </Modal>

                
            </Card>
        </Fragment>
    );
};

export default TreatmentPlan;
